import { SxProps, Typography, TypographyProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

interface PageHeaderTitleProps extends TypographyProps {
  children: React.ReactNode;
  hasSubtitle?: boolean;
  sx?: SxProps;
}

function PageHeaderTitle({ children, hasSubtitle, sx, ...rest }: PageHeaderTitleProps) {
  return (
    <Typography
      variant="h1"
      {...rest}
      sx={{
        fontWeight: '600',
        color: (theme: Theme) => theme.palette?.primary.main,
        margin: 0,
        padding: {
          xs: hasSubtitle ? '0px' : '5px',
          md: hasSubtitle ? '0px' : '10px',
          xl: hasSubtitle ? '0px 15px 15px' : '15px',
        },
        width: '100%',
        fontSize: { xs: '24px', md: '28px', xl: '30px' },
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default PageHeaderTitle;
